class BomCart extends HTMLElement {
    
    static selectors = {
        shippingMethod: '.js-set-shipping-method',
        shippingIdInput: '[name="EcomCartShippingmethodID"]',
        quantityInput: '.js-bom-cart-quantity-input',
        totalPrice: '.js-bom-cart-total-price',
        orderLine: '.js-bom-orderLine',
        orderLinePrice: '.js-bom-orderLine-price'
    }
    
    static modifiers = {
        active: 'active'
    }
    
    static events = {
        click: 'click',
        change: 'change'
    }
    
    constructor(){
        super();
        this.shippingMethods = this.querySelectorAll(BomCart.selectors.shippingMethod);
        this.targetInput = this.querySelector(BomCart.selectors.shippingIdInput);
        this.totalPrices = this.querySelectorAll(BomCart.selectors.totalPrice);
        this.domParser = new DOMParser();
    }
    
    connectedCallback(){
        this.addEventListener(BomCart.events.click, this, true);
        this.addEventListener(BomCart.events.change, this, true);
    }
    
    handleEvent(event){
        switch (event.type) {
            case BomCart.events.click:
                if(event.target.matches(BomCart.selectors.shippingMethod)){
                    event.preventDefault();
                    const target = event.target;
                    this.updateShipping(target);
                } else if(event.target.closest(BomCart.selectors.shippingMethod)){
                    event.preventDefault();
                    const target = event.target.closest(BomCart.selectors.shippingMethod);
                    this.updateShipping(target);
                }
                break;
            case BomCart.events.change:
                if(event.target.matches(BomCart.selectors.quantityInput)){
                    const target = event.target;
                    this.updatePrice(target);
                }
                break;
        }
    }
    
    
    updateShipping(domElm){
        this.shippingMethods.forEach(sh => sh.classList.remove(BomCart.modifiers.active));
        domElm.classList.add(BomCart.modifiers.active);
        this.targetInput.value = domElm.dataset.id;
    }
    
    async updatePrice(domElm){
        
        const param = domElm.dataset.param;
        const url = new URL(location.href);
        url.searchParams.set(param, domElm.value);
        
        const response = await fetch(url);
        const htmlStr = await response.text();
        const html = this.domParser.parseFromString(htmlStr, 'text/html');

        const orderLine = domElm.closest(BomCart.selectors.orderLine);
        const orderLinePrice = orderLine.querySelector(BomCart.selectors.orderLinePrice);
        const orderLinePriceElem = html.querySelector(`${BomCart.selectors.orderLinePrice}[data-id="${orderLinePrice.dataset.id}"]`);
        
        if(orderLinePriceElem !== null){
            orderLinePrice.innerHTML = orderLinePriceElem.innerHTML;
        }
        
        const totalPriceElm = html.querySelector(BomCart.selectors.totalPrice);
        if(totalPriceElm !== null){
            this.totalPrices.forEach(tp => tp.innerHTML = totalPriceElm.innerHTML);
        }
        
        
    }
}

customElements.define('bom-cart', BomCart);